/*
Utilities to display the name instead of the value of the roles
 */

export const RoleArray = [
  {
    label: 'Fachadministrator',
    value: 'GROUP_ADMIN',
  },
  {
    label: 'Fachnutzer',
    value: 'INTERNAL_USER',
  },
  {
    label: 'Superadmin',
    value: 'SUPER_SUBJECT_ADMIN',
  }
];

export const RoleMap = {
  GROUP_ADMIN: 'Fachadministrator',
  INTERNAL_USER: 'Fachnutzer',
  SUBJECT_ADMIN: 'Nicht vorgesehen',
};

export const RoleAdminProfile = {
  name: 'FachAdministrator',
  id: 12,
};

export const RoleVerwaltungProfile = {
  name: 'Verwaltung',
  id: 3,
};

// functions for role-booleans
export const actions = {
  UserCreate: 'UserCreate', // OK
  UserSetPassword: 'UserSetPassword', // OK
  UserSetRole: 'UserSetRole',
  UserDelete: 'UserDelete', // OK
  UserShowInfoAll: 'UserShowInfoAll',
  UserShowInfoOwn: 'UserShowInfoOwn',
  UserEditInfo: 'UserEditInfo', // OK
  ForlderPersonalRead: 'ForlderPersonalRead',
  FolderPersonalEdit: 'FolderPersonalEdit',
  FolderPersonalSave: 'FolderPersonalSave',
  FolderPersonalDelete: 'FolderPersonalDelete',
  FolderGroupRead: 'FolderGroupRead',
  FolderGroupEdit: 'FolderGroupEdit',
  FolderGroupSave: 'FolderGroupSave',
  FolderGroupDelete: 'FolderGroupDelete',
  FolderTransferRead: 'FolderTransferRead',
  FolderTransferEdit: 'FolderTransferEdit',
  FolderTransferDelete: 'FolderTransferDelete',
  FolderTransferSave: 'FolderTransferSave',
  ReleasePersonalToGroup: 'ReleasePersonalToGroup',
  ReleasePersonalToTransfer: 'ReleasePersonalToTransfer',
  ReleaseGroupToTransfer: 'ReleaseGroupToTransfer',
  ReleasePersonalAllToTransfer: 'ReleasePersonalAllToTransfer',
  ReleaseGroupAllToTransfer: 'ReleaseGroupAllToTransfer',
  ImportMetaNew: 'ImportMetaNew',
  ImportValue: 'ImportValue',
  ImportMetaOverwrite: 'ImportMetaOverwrite',
  EvaluationSupFederal: 'EvaluationSupFederal',
  EvaluationSupLand: 'EvaluationSupLand',
  EvaluationOrigFederal: 'EvaluationOrigFederal',
  EvaluationOrigLand: 'EvaluationSupLand',
  StandardFolderAdmin: 'StandardFolderAdmin',
  StandardTableSave: 'StandardTableSave',
  StandardTableRead: 'StandardTableRead',
  StandardTableEdit: 'StandardTableEdit',
  CubeImport: 'CubeImport',
  CubeAssign: 'CubeAssign',
  KeyfigureEdit: 'KeyfigureEdit',
  KeyfigureRead: 'KeyfigureRead',
};

export const roles = {
  NO_USER: 'NO_USER',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  FEDERAL_GROUP_ADMIN: 'FEDERAL_GROUP_ADMIN',
  FEDERAL_INTERNAL_USER: 'FEDERAL_INTERNAL_USER',
  LAND_GROUP_ADMIN: 'LAND_GROUP_ADMIN',
  SUPER_SUBJECT_ADMIN: 'SUPER_SUBJECT_ADMIN',
  LAND_INTERNAL_USER: 'LAND_INTERNAL_USER',
  MINISTRY_GROUP_ADMIN: 'MINISTRY_GROUP_ADMIN',
  MINISTRY_INTERNAL_USER: 'MINISTRY_INTERNAL_USER',
  EXTERNAL_GROUP_ADMIN: 'EXTERNAL_GROUP_ADMIN',
  EXTERNAL_INTERNAL_USER: 'EXTERNAL_INTERNAL_USER',
};

export const mappings = new Map();
const allAdmins = [
  roles.FEDERAL_GROUP_ADMIN,
  roles.LAND_GROUP_ADMIN,
  roles.MINISTRY_GROUP_ADMIN,
  roles.EXTERNAL_GROUP_ADMIN,
  roles.SUPER_SUBJECT_ADMIN,
];
const allUsers = [
  roles.FEDERAL_GROUP_ADMIN,
  roles.LAND_GROUP_ADMIN,
  roles.MINISTRY_GROUP_ADMIN,
  roles.EXTERNAL_GROUP_ADMIN,
  roles.FEDERAL_INTERNAL_USER,
  roles.LAND_INTERNAL_USER,
  roles.MINISTRY_INTERNAL_USER,
  roles.EXTERNAL_INTERNAL_USER,
];
const noUsers = [];
// mappings.set(actions., [roles.]); // template
mappings.set(actions.UserCreate, allAdmins);
mappings.set(actions.UserSetPassword, allAdmins);
mappings.set(actions.UserSetRole, allAdmins);
mappings.set(actions.UserDelete, allAdmins);
mappings.set(actions.UserShowInfoAll, allAdmins);
mappings.set(actions.UserShowInfoOwn, [roles.FEDERAL_GROUP_ADMIN,
  roles.LAND_GROUP_ADMIN, roles.MINISTRY_GROUP_ADMIN]);
mappings.set(actions.UserEditInfo, allAdmins);
mappings.set(actions.ForlderPersonalRead, allUsers);
mappings.set(actions.FolderPersonalEdit, allAdmins);
mappings.set(actions.FolderPersonalSave, allAdmins);
mappings.set(actions.FolderPersonalDelete, allAdmins);
mappings.set(actions.FolderGroupRead, allUsers);
mappings.set(actions.FolderGroupEdit, allUsers);
mappings.set(actions.FolderGroupSave, allAdmins);
mappings.set(actions.FolderGroupDelete, allAdmins);
mappings.set(actions.FolderTransferRead, allUsers);
mappings.set(actions.FolderTransferEdit, allUsers);
mappings.set(actions.FolderTransferDelete, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.FolderTransferSave, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ReleasePersonalToGroup, allAdmins);
mappings.set(actions.ReleasePersonalToTransfer, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ReleaseGroupToTransfer, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ReleasePersonalAllToTransfer, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ReleaseGroupAllToTransfer, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ImportMetaNew, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ImportValue, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.ImportMetaOverwrite, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.EvaluationSupFederal, allUsers);
mappings.set(actions.EvaluationSupLand, noUsers);
mappings.set(actions.EvaluationOrigFederal, noUsers);
mappings.set(actions.EvaluationOrigLand, noUsers);
mappings.set(actions.StandardFolderAdmin, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.StandardTableSave, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.StandardTableRead, allUsers);
mappings.set(actions.StandardTableEdit, allUsers);
mappings.set(actions.CubeImport, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.CubeAssign, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.KeyfigureEdit, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.KeyfigureRead, allUsers);
mappings.set(actions.DataSetAllWrite, [roles.SUPER_SUBJECT_ADMIN]);
mappings.set(actions.DataSetLandWrite, [roles.FEDERAL_GROUP_ADMIN]);
mappings.set(actions.DataSetRead, allUsers);

export function hasPermission(userRights, action) {
  if (!userRights?.accessLevel) {
    return false;
  }
  if (mappings.has(action)) {
    return mappings.get(action).includes(userRights.accessLevel);
  }
  return false;
}

export function returnUserRights() {
  const group = (sessionStorage.getItem('group'));
  const isMinistery = group.includes('Ministerium');
  // const role = isMinistery ? 'MINISTERY' : sessionStorage.getItem('role'); 
  const role = sessionStorage.getItem('role'); // ADBHSSTAT-432
  console.log('RIGHTS#-1', sessionStorage.getItem('role'));
  const admin = (role === 'GROUP_ADMIN');
  const prefix = (group === 'StBA') ? 'FEDERAL_' : 'LAND_';
  const accessLevel = prefix + role;
  const land = group.length > 4 ? group.split(' ')[1] : 'Bund';
  const userRights = {
    role,
    group,
    admin,
    accessLevel,
    land,
  };
  return userRights;
}
